const CALISTA_ADVISORY_SYSTEM_CONFIG_URL = `${process.env.REACT_APP_CALISTA_ADVISORY_URL}/cal-cia/cia-admin/system-config`

const CIASystemConfigApiUrls = {
    GET: `${CALISTA_ADVISORY_SYSTEM_CONFIG_URL}/get`,
    PUT: `${CALISTA_ADVISORY_SYSTEM_CONFIG_URL}/update`
}

export default CIASystemConfigApiUrls
